import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyle = style =>
	makeStyles(theme => {
		const {
			breakpoints: { down },
		} = theme;

		return {
			root: {
				height: style?.height ? style?.height : '5px',
				background: theme.palette.action.main,
				borderRadius: '30px',
				...style,
				[down('sm')]: {
					width: '55%',
					height: '3px',
				},
			},
		};
	});

const Divider = ({ style, className }) => {
	const classes = useStyle(style)();
	return <div className={[classes.root, className].join(' ')}></div>;
};

export default Divider;
